var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-download"},[_c('breadcrumb'),_c('div',{staticClass:"layer-container"},[_c('h2',{staticClass:"page-title"},[_vm._v("法規表單")]),_c('download-ls',{attrs:{"title":"法規資訊","menu-id":"0610"}}),_c('download-ls',{attrs:{"title":"表單下載","menu-id":"0620"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }